<div class="container">
  <h4>{{contributeMarket.marketCode}} {{contributorCode}} {{'MarketMonitor.monitor.marketContribute.header' | translate}}</h4>

  @if (contributeMarket.isMarketOpen === true  && isLoading === false) {
    <div [@slider]="contributeMarket.isMarketOpen === true  && isLoading === false? 'show' : null" class="slider">
      <div id="contributerInputWindow" class="mt-3 scrollableTable {{hasMaxHeight === true ? 'scrollableTableHeight' : ''}}">
        <form>
          <table id="contributeTable" mat-table [dataSource]="dataSourceNew">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef style="width: 40%;"> {{'MarketMonitor.monitor.marketContribute.thName' | translate}}</th>
              <td mat-cell *matCellDef="let element">{{element.instrumentDescription}}</td>
            </ng-container>
            <ng-container matColumnDef="space">
              <th mat-header-cell *matHeaderCellDef style="width: auto;"> </th>
              <td mat-cell *matCellDef="let element"></td>
            </ng-container>
            <ng-container matColumnDef="level">
              <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'MarketMonitor.monitor.marketContribute.thLevel' | translate}}</th>
              <td mat-cell *matCellDef="let element" [style.color]="element.notes.trim() !== '' ? (element.instrumentAccepted ? 'green' : 'red') : ''">{{element.level}}</td>
            </ng-container>
            <ng-container matColumnDef="cof">
              <th mat-header-cell *matHeaderCellDef style="width: 30%;"> {{'MarketMonitor.monitor.marketContribute.thCOF' | translate}}</th>
              <td mat-cell *matCellDef="let element">
                <input class="tableInput" [ngClass]="{'hasErrorClass': (!element.newRate) && hasSubmitted === true}" matInput type="text" [readonly]="element.level !== 3" [(ngModel)]="element.newRate" [ngModelOptions]="{standalone: true}"
                  required (focusout)="EnablebtnSubmit(element)" />
                </td>
              </ng-container>
              <ng-container matColumnDef="fsaCOF">
                <th mat-header-cell *matHeaderCellDef style="width: 30%;"> {{'MarketMonitor.monitor.marketContribute.thFSACOF' | translate}}</th>
                <td mat-cell *matCellDef="let element">
                  {{element.fsaCOF}}
                </td>
              </ng-container>
              <ng-container matColumnDef="spread">
                <th mat-header-cell *matHeaderCellDef style="width: 30%;"> {{'MarketMonitor.monitor.marketContribute.thSpread' | translate}}</th>
                <td mat-cell *matCellDef="let element">
                  <input class="tableInput" (keyup)="checkSpread(element)" [ngClass]="{'hasErrorClass': (!element.newSpread) && hasSubmitted === true}" matInput type="text" [(ngModel)]="element.newSpread" [ngModelOptions]="{standalone: true}"
                    required (focusout)="EnablebtnSubmit(element)" />
                  </td>
                </ng-container>
                <ng-container matColumnDef="reason">
                  <th mat-header-cell *matHeaderCellDef style="width: 30%;"> {{'MarketMonitor.monitor.marketContribute.lblReason' | translate}}</th>
                  <td mat-cell *matCellDef="let element">
                    <mat-form-field class="col-12" [ngClass]="{'ng-touched ng-invalid mat-form-field-invalid': !element.listReasonId && element.isReasonRequired}">
                      <mat-label >{{'MarketMonitor.monitor.marketContribute.lblReason' | translate}}</mat-label>
                      <mat-select (selectionChange)="EnablebtnSubmit()"  [(ngModel)]="element.listReasonId" [ngModelOptions]="{standalone: true}" [required]="element.isReasonRequired">
                        @for (reason of reasons; track reason) {
                          <mat-option [value]="reason.id">{{reason.value}}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="newRate">
                  <th mat-header-cell *matHeaderCellDef style="width: 30%;"> {{'MarketMonitor.monitor.marketContribute.thNewRate' | translate}}</th>
                  <td mat-cell *matCellDef="let element">
                    <input class="tableInput" [ngClass]="{'hasErrorClass': (!element.newRate) && hasSubmitted === true}" matInput type="text" [(ngModel)]="element.newRate" [ngModelOptions]="{standalone: true}"
                      required (focusout)="EnablebtnSubmit(element)" />
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="newVolume">
                    <th mat-header-cell *matHeaderCellDef style="width: 30%;"> {{'MarketMonitor.monitor.marketContribute.thNewVolume' | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                      @if (element.calculationType === 'wav') {
                        <input class="tableInput" [ngClass]="{'hasErrorClass': (!element.newVolume) && hasSubmitted === true}" matInput type="number" min="0" [(ngModel)]="element.newVolume" [ngModelOptions]="{standalone: true}"
                          required (focusout)="EnablebtnSubmit()"/>
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="loading">
                    <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'tblLoading' | translate}}... </th>
                  </ng-container>
                  <ng-container matColumnDef="noData">
                    <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'MarketMonitor.monitor.marketContribute.tblNoData' | translate}}...
                    </th>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
                  <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSourceNew!=null}"></tr>
                  <tr mat-footer-row *matFooterRowDef="['noData']"
                  [ngClass]="{'hide':dataSourceNew!=null && instrumentLength != 0}"></tr>
                </table>
              </form>
            </div>
            <div class="mt-3">
              <button [disabled]="!canEnablebtnSubmit" mat-raised-button color="primary" type="button" (click)="OnSubmitClick()">{{'btnSubmit' |
              translate}}</button> &nbsp;
              <button style="float: right; margin-left: 10px;" mat-raised-button color="secondary" (click)="OnCancel()">{{'btnCancel' | translate}}</button>
              <button style="float: right;" [disabled]="contributeMarket.canEnableBtnDiscard === false" mat-raised-button color="secondary" (click)="OnDiscard()">{{'btnDiscard' | translate}}</button>
            </div>
          </div>
        }
        @if (contributeMarket.isMarketOpen === false && isLoading === false) {
          <div [@slider]="contributeMarket.isMarketOpen === false  && isLoading === false? 'show' : null" class="slider">
            <p>{{'MarketMonitor.monitor.marketContribute.notReady' | translate}}</p>
            <button mat-raised-button color="secondary" (click)="OnCancel()">{{'btnClose' | translate}}</button>
          </div>
        }
        @if (isLoading === true) {
          <div [@slider]="isLoading === true? 'show' : null" class="slider">
            <p>{{'tblLoading' | translate}}...</p>
          </div>
        }
      </div>

